import { createHashHistory, createBrowserHistory } from 'history'

const history =
  import.meta.env.VITE_REACT_APP_STATIC === 'static'
    ? createHashHistory()
    : createBrowserHistory()

export default history
